import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import Particle from "../Particle";
import Loading from "../Loading";
import { useData } from "../../context/DataContext";
import { useTranslation } from "react-i18next";
import { AiOutlineDownload } from "react-icons/ai";
import { FaFileDownload } from "react-icons/fa";

function ResumeNew() {
  const { t, i18n } = useTranslation();
  const { profile, loading } = useData();
  const lang = i18n.language.split("-")[0];

  const cvUrl = profile?.resumeUrl || "/resume.pdf";

  if (loading) {
    return <Loading message="Loading Resume..." />;
  }

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Container>
          <Row className="mb-5">
            <Col>
              <h1 className="project-heading text-center">
                <FaFileDownload className="me-3" />
                {t("my_resume", "My Resume / CV")
                  .split(" ")
                  .slice(0, 1)
                  .join(" ")}{" "}
                <strong className="purple">
                  {t("my_resume", "My Resume / CV")
                    .split(" ")
                    .slice(1)
                    .join(" ")}
                </strong>
              </h1>
              <p
                className="text-center text-white"
                style={{ fontSize: "1.1rem", marginTop: "20px" }}
              >
                {lang === "uz"
                  ? "Mening to'liq rezyumemni yuklab oling va ko'rib chiqing."
                  : "Download my complete resume to learn more about my qualifications."}
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center mb-4">
            <Col md="auto">
              <Button
                variant="primary"
                href={cvUrl}
                target="_blank"
                style={{
                  fontSize: "1.2rem",
                  padding: "12px 40px",
                  backgroundColor: "#c770f0",
                  border: "none",
                  borderRadius: "10px",
                }}
              >
                <AiOutlineDownload />
                &nbsp;{lang === "uz" ? "CV Yuklab Olish" : "Download CV"}
              </Button>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} className="text-center">
              <div
                style={{
                  backgroundColor: "rgba(25, 25, 35, 0.8)",
                  border: "1px solid rgba(199, 112, 240, 0.3)",
                  borderRadius: "15px",
                  padding: "40px",
                  marginTop: "30px",
                }}
              >
                <h3 className="purple mb-4">📄 Professional Resume</h3>
                <p
                  className="text-white"
                  style={{ fontSize: "1.1rem", lineHeight: "1.8" }}
                >
                  {t(
                    "resume_description",
                    "My resume contains detailed information about my professional experience, educational background, technical skills, and certifications. Click the download button above to view it in PDF format."
                  )}
                </p>

                <div className="mt-4">
                  <Button
                    variant="outline-light"
                    href={cvUrl}
                    target="_blank"
                    style={{
                      fontSize: "1rem",
                      padding: "10px 30px",
                      borderColor: "#c770f0",
                      color: "#c770f0",
                      borderRadius: "8px",
                    }}
                  >
                    {lang === "uz" ? "Brauzerda ochish" : "Open in Browser"}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
    </div>
  );
}

export default ResumeNew;
